import { connect, useDispatch } from "react-redux";
import { getApps } from "../../../../action/masters/appActionCreator";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { IFacultyApps } from "../../../../models/dashboard/facultyDashboard";
import { IApps } from "../../../../models/master/apps";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setApps } from "../../../../store/slices/master/appSlice";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const FacultyApps = (props: IFacultyApps) => {
  const { snapShots, apps, getAllApps } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(`${ROUTER_URL.RESOURCES}#resource-apps`);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.facultyApps);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllApps(pageBlockId.facultyApps, limit.five);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap card-faculty-apps" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Faculty Apps</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="row">
          {apps
            ?.filter((app: IApps) => app.displayOrNot)
            .map((app: IApps) => (
              <div className="col-lg-12" key={app.id || app.name}>
                <div className="btncard">
                  <a href={app.url} target="_blank" rel="noopener noreferrer">
                    <img src={baseURL + app.image} alt={app.name || "App"} />
                    <h3>{app.name}</h3>
                    <span>
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt="arrow"
                      />
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllApps: (pageBlockId: number, noOfItems: number) =>
    getApps(undefined, pageBlockId,undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    apps: state.app.apps,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyApps);
